import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { authStateSelector } from '../../store/selectors/userSelector'
import { useLocation } from 'react-router'

const Auth = (): JSX.Element => {
  const location = useLocation()
  const isAuthenticated = useSelector(authStateSelector)
  if (isAuthenticated)
    return <Navigate to="/dashboard" state={{ from: location }} replace />

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/auth/login" replace />} />
      </Routes>
      <Outlet />
    </>
  )
}

export default Auth
